<section class="search-field-wrapper Auto_Search_Wrapper"
         genTooltip
         [appendToBody]="true"
         [ngClass]="{'loading':load,
                     'complete':!load && !!previousValue && previousValue === searchVal,
                     'ready':previousValue !== searchVal}">
  <input class="search-input Auto_Input_Search"
         placeholder="{{placeholder | stringTranslate}}"
         [(ngModel)]="value"
         (keyup.enter)="search()"
         (keyup.esc)="clear()"
  />
  <section class="icons" [ngClass]="{'search-mode': load}">
    <i class="clear-icon fa fa-times-circle Auto_Button_Clear" *ngIf="!!value" (click)="clear()"></i>
    <i class="search-icon icon__search Auto_Button_Search" (click)="search()"></i>
    <section class="loader-section">
      <span>&nbsp;|&nbsp;</span>
      <i class="loader-icon fa fa-circle-o-notch"></i>
    </section>
  </section>
</section>
